var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "intro p-3" }, [
    _c(
      "div",
      { staticStyle: { display: "none" }, attrs: { id: "wiki-introduction" } },
      [
        _vm.loading
          ? _c("div", { staticClass: "loading" }, [
              _c("img", {
                attrs: {
                  src: require("../../assets/images/gif-loading.gif"),
                  alt: "loading"
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.intro.length != 0
          ? _c("p", [
              _vm._v("\n      " + _vm._s(_vm.intro) + "\n      "),
              _c("br"),
              _c("br"),
              _vm._v("\n      資料來源："),
              _c(
                "a",
                {
                  staticClass: "wiki-link",
                  attrs: { href: _vm.link, target: "_blank" }
                },
                [_vm._v("維基百科")]
              )
            ])
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "categ-blocks row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-xl-4 mt-lg-5 mt-sm-4"
      },
      _vm._l(_vm.categs, function(categ, index) {
        return index !== 0
          ? _c(
              "div",
              {
                key: categ.title,
                staticClass: "col mb-5",
                on: {
                  click: function($event) {
                    _vm.$emit("changeTab", categ.title)
                  }
                }
              },
              [
                _c("div", { staticClass: "card border-0 categ-block" }, [
                  _c("div", { staticClass: "row no-gutters" }, [
                    _c("div", { staticClass: "col-sm-4 col-md-3" }, [
                      _c("img", {
                        staticClass: "card-img",
                        attrs: { src: _vm.tabImages[categ.id] }
                      }),
                      _c("p", [_vm._v(_vm._s(categ.title))])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-8 col-md-9" }, [
                      _c("div", { staticClass: "categ-content" }, [
                        _vm.ordinaryDisplay[categ.id]
                          ? _c("p", { staticClass: "card-title orange" }, [
                              _vm._v(_vm._s(categ.topstats[0].title))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.noTownValue[categ.id]
                          ? _c("p", { staticClass: "card-text orange" }, [
                              _vm._v("（" + _vm._s(_vm.thisCountyname) + "之）")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.noTownValue[categ.id]
                          ? _c("p", { staticClass: "card-text orange" }, [
                              _vm._v(_vm._s(categ.topstats[0].title))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "card-text h2 orange",
                            attrs: { title: _vm.topStatsValueKSep[index] }
                          },
                          [_vm._v(_vm._s(_vm.topStatsValueKSep[index]))]
                        )
                      ])
                    ])
                  ])
                ])
              ]
            )
          : _vm._e()
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }